import React from 'react';
import { NavLink } from 'reactstrap';
import classnames from 'classnames';
import './styles.scss';
import { Icon, TsrSvgIcon } from 'tacho-ui';

interface TabItemProps {
    label: string;
    isActive: boolean;
    href?: string;
    disabled?: boolean;
    isUpperCase?: boolean;
    isClosable?: boolean;
    isResetable?: boolean;
    activeIcon?: Icon;
    inModal?: boolean;
    linkRef: (ref: HTMLLIElement) => void;
    onClick: () => void;
    onClose: () => void;
    onResetDefault: () => void;
    onNewTab?: () => void;
}

export class TabItemComponent extends React.Component<TabItemProps> {
    public render(): JSX.Element {
        const optionalProps = this.props.href ? { href: this.props.href } : {};
        const navItemCloseClassName = this.props.isActive ? 'navItemClose' : '';
        return (
            <li
                ref={(ref: any) => this.props.linkRef(ref)}
                className={classnames(
                    { activeTab: this.props.isActive },
                    { inactiveTab: !this.props.isActive },
                    { inModal: this.props.inModal },
                    'navTabItem',
                    'nav-item',
                )}
            >
                {this.props.activeIcon && (
                    <TsrSvgIcon className={`tabIcon ${navItemCloseClassName} me-1`} icon={this.props.activeIcon} size="large" />
                )}

                <NavLink disabled={this.props.disabled} onClick={(): void => this.props.onClick()} {...optionalProps}>
                    {this.props.isUpperCase ? this.props.label.toUpperCase() : this.props.label}
                </NavLink>
                {this.props.onNewTab ? (
                    <TsrSvgIcon
                        className={navItemCloseClassName}
                        icon={Icon.Plus}
                        onClick={() => this.props.onNewTab && this.props.onNewTab()}
                        pointer
                        size="large"
                    />
                ) : (
                    <></>
                )}
                {this.props.isClosable && (
                    <TsrSvgIcon
                        pointer
                        icon={Icon.Close}
                        className={navItemCloseClassName}
                        onClick={() => this.props.onClose()}
                        size="large"
                    />
                )}
                {this.props.isResetable && (
                    <TsrSvgIcon
                        className={navItemCloseClassName}
                        icon={Icon.Refresh}
                        onClick={() => this.props.onResetDefault()}
                        size="large"
                        pointer
                    />
                )}
            </li>
        );
    }
}
